module.exports = __webpack_public_path__ + "img/6.6313c812.jpg";